/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClassificationsControllerFindAllQueryResponse, ClassificationsControllerFindAllPathParams, ClassificationsControllerFindAllQueryParams, ClassificationsControllerFindAll401, ClassificationsControllerFindAll403 } from "../../models/documentClassificationsController/ClassificationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { classificationsControllerFindAll } from "../../clients/document-classificationsService/classificationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const classificationsControllerFindAllQueryKey = (documentId: ClassificationsControllerFindAllPathParams["documentId"], renditionId: ClassificationsControllerFindAllPathParams["renditionId"], params: ClassificationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/classifications',
  params: {
    documentId: documentId,
    renditionId: renditionId
  }
}, ...(params ? [params] : [])] as const;
export type ClassificationsControllerFindAllQueryKey = ReturnType<typeof classificationsControllerFindAllQueryKey>;
export function classificationsControllerFindAllQueryOptions(documentId: ClassificationsControllerFindAllPathParams["documentId"], renditionId: ClassificationsControllerFindAllPathParams["renditionId"], params?: ClassificationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = classificationsControllerFindAllQueryKey(documentId, renditionId, params);
  return queryOptions<ClassificationsControllerFindAllQueryResponse, ResponseErrorConfig<ClassificationsControllerFindAll401 | ClassificationsControllerFindAll403>, ClassificationsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return classificationsControllerFindAll(documentId, renditionId, params, config);
    }
  });
}

/**
 * @description Returns classifications with JSON:API pagination, sorting, filtering, and includes. Use ?include=results to include classification results.
 * @summary List all classifications for a rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/classifications}
 */
export function useClassificationsControllerFindAll<TData = ClassificationsControllerFindAllQueryResponse, TQueryData = ClassificationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ClassificationsControllerFindAllQueryKey>(documentId: ClassificationsControllerFindAllPathParams["documentId"], renditionId: ClassificationsControllerFindAllPathParams["renditionId"], params?: ClassificationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClassificationsControllerFindAllQueryResponse, ResponseErrorConfig<ClassificationsControllerFindAll401 | ClassificationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? classificationsControllerFindAllQueryKey(documentId, renditionId, params);
  const query = useQuery({
    ...classificationsControllerFindAllQueryOptions(documentId, renditionId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClassificationsControllerFindAll401 | ClassificationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}